import React, { Component } from "react";
import { API, Storage } from "aws-amplify";
import { Form } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import {  Card , ListGroup,ListGroupItem,  Button, Alert , Accordion, Modal } from "react-bootstrap";
import marked from "marked";
import config from "../config";
import "./Notes.css";
import { s3Upload } from "../libs/awsLib";
import ReactDOM from 'react-dom'
import MdEditor from 'react-markdown-editor-lite'
import MarkdownIt from 'markdown-it'
const MOCK_DATA = "Hello.\n\n * This is markdown.\n * It is fun\n * Love it or leave it."


export default class EditPage extends Component {
    constructor(props) {
        super(props);

        this.file = null;

        this.state = {
            isLoading: null,
            isDeleting: null,
            note: null,
            content: "",
            attachmentURL: null,
            profile:{},
            linkedinRoute: '',
            canShowProfile: false,
            mdText:'',
            mdHtml:'',
            mdParser:new MarkdownIt()
        };
    }

    async componentDidMount() {
        const readmePath = require("../files/basico.md");
        fetch(readmePath)
        .then(response => {
          return response.text()
        })
        .then(text => {
            console.log({text})
          this.setState({
            ...this.state,
            mdText: text
          })
        })
        console.log("readmePath",readmePath)
        // this.setState({...this.state,mdText:readmePath }) 
        // fetch(readmePath)
        // .then(response => {
        //   return response.text()
        // })
        // .then(text => {
        //   this.setState({
        //     ...this.state,
        //     markdown: marked(text)
        //   })
        // })
        // try {
        //     let attachmentURL;
        //     const note = await this.getNote();
        //     const { content, attachment } = note;

        //     if (attachment) {
        //         attachmentURL = await Storage.vault.get(attachment);
        //     }

        //     this.setState({
        //         note,
        //         content,
        //         attachmentURL
        //     });
        // } catch (e) {
        //     alert(e);
        // }
    }

    handleEditorChange =  () => async e => {
        console.log('handleEditorChange', e)
        let nenitas = this.state.mdParser.render(this.state.mdText)
        console.log("Esta es nenitas", nenitas)
        // console.log("Veamos el state", this.state)
            this.setState({
                ...this.state, 
                mdHtml:e.html
              })
    }

    handleImageUpload =  () => async e => {    
        console.log("Este es mi e", e)
        // const reader = new FileReader()
        // reader.onload = () => {      
        //   const convertBase64UrlToBlob = (urlData) => {  
        //     let arr = urlData.split(','), mime = arr[0].match(/:(.*?);/)[1]
        //     let bstr = atob(arr[1])
        //     let n = bstr.length
        //     let u8arr = new Uint8Array(n)
        //     while (n--) {
        //       u8arr[n] = bstr.charCodeAt(n)
        //     }
        //     return new Blob([u8arr], {type:mime})
        //   }
        //   const blob = convertBase64UrlToBlob(reader.result)
        //   setTimeout(() => {
        //     // setTimeout 模拟异步上传图片
        //     // 当异步上传获取图片地址后，执行calback回调（参数为imageUrl字符串），即可将图片地址写入markdown
        //     callback('https://avatars0.githubusercontent.com/u/21263805?s=40&v=4')
        //   }, 1000)
        // }
        // reader.readAsDataURL(file)
    }


    syncUpProfile = () =>async e=>{
        try {
            const myProfile = await API.post("talent", `/linkedin`, {
                body:{
                    linkedinProfile: this.state.linkedinRoute
                }
            })
            console.log("Estos son mis note", myProfile)
            this.setState({...this.state, profile: myProfile.employee, canShowProfile:true }) 
        } catch (e) {
            alert(e);
        }

    }

    getNote() {
        return API.get("notes", `/notes/${this.props.match.params.id}`);
    }


    validateForm() {
        return this.state.content.length > 0;
    }

    formatFilename(str) {
        return str.replace(/^\w+-/, "");
    }

    handleChange = event => {
        this.setState({
            ["linkedinRoute"]: event.target.value
        });
    }

    handleFileChange = event => {
        this.file = event.target.files[0];
    }

    saveNote(note) {
        return API.put("notes", `/notes/${this.props.match.params.id}`, {
            body: note
        });
    }

    handleSubmit = async event => {
        let attachment;

        event.preventDefault();

        if (this.file && this.file.size > config.MAX_ATTACHMENT_SIZE) {
            alert(`Please pick a file smaller than ${config.MAX_ATTACHMENT_SIZE / 1000000} MB.`);
            return;
        }

        this.setState({ isLoading: true });

        try {
            if (this.file) {
                attachment = await s3Upload(this.file);
            }

            await this.saveNote({
                content: this.state.content,
                attachment: attachment || this.state.note.attachment
            });
            this.props.history.push("/");
        } catch (e) {
            alert(e);
            this.setState({ isLoading: false });
        }
    }



    deleteNote() {
        return API.del("notes", `/notes/${this.props.match.params.id}`);
    }

    handleDelete = async event => {
        event.preventDefault();

        const confirmed = window.confirm(
            "Are you sure you want to delete this note?"
        );

        if (!confirmed) {
            return;
        }

        this.setState({ isDeleting: true });

        try {
            await this.deleteNote();
            this.props.history.push("/");
        } catch (e) {
            alert(e);
            this.setState({ isDeleting: false });
        }
    }


    renderProfile() {
        return (
            <div className="my-profile">
            <Card style={{ width: '18rem' }}>
                <Card.Img variant="top" src={this.state.profile.profilePicture || 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Smiley.svg/220px-Smiley.svg.png'} />
                <Card.Body>
                    <Card.Title>{this.state.profile.profileName}</Card.Title>
                    <Card.Text>
                    {this.state.profile.profileDescription}
                    </Card.Text>
                </Card.Body>
                <ListGroup className="list-group-flush">
                    <ListGroupItem>
                        
                        Cras justo odio
                        
                    </ListGroupItem>
                    <ListGroupItem>Dapibus ac facilisis in</ListGroupItem>
                    <ListGroupItem>Vestibulum at eros</ListGroupItem>
                </ListGroup>
                <Card.Body>
                    <Card.Link href="#">Card Link</Card.Link>
                    <Card.Link href="#">Another Link</Card.Link>
                </Card.Body>
            </Card>    

            </div>
        )


    }
    render() {
        console.log("this.state", this.state)
        console.log("Que bello ha cambiado" , this.state.profile.profilePicture)
        // const { markdown } = this.state;
        return (
            <div className="Notes">
                    <div >
                        <MdEditor
                        value={this.state.mdText}
                        renderHTML={(text) => this.state.mdParser.render(text)}
                        onChange={this.handleEditorChange()}
                        onImageUpload={this.handleImageUpload()}
                        />                
                    </div>
                    <div>
                    <section>
                    <article dangerouslySetInnerHTML={{__html: this.state.mdHtml}}></article>
                </section>
                    </div>
            </div>
        );
    }
}
